import { Box, Button } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import CircularProgress from '@mui/material/CircularProgress';
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import axios from "axios";
import "./addNonUpdatedContracts.css";

const AddNonUpdatedContracts = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [file, setFile] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.append("fileUpload", file);

      await axios.post("/api/add-nonUpdated-Contracts", formData);

      toast.success("File successfully uploaded!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {isLoading && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255, 255, 255, 0.8)",
          zIndex: 999,
          backdropFilter: "blur(2px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </div>
    )}
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="ADD NON UPDATED CONTRACTS"
            subtitle="Upload a csv file with non updated contracts"
          />       
          <form onSubmit={handleFormSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <input
                type="file"
                name="fileUpload"
                onChange={(e) => setFile(e.target.files[0])}
                required
              />
            </Box>
            <Box display="flex" justifyContent="start" mt="20px">
              <Button type="submit" color="success" variant="contained">
                Upload File
              </Button>
            </Box>
            <ToastContainer />
          </form>
        </Box>
      </main>
    </div>
    </>
  );
};

export default AddNonUpdatedContracts;